/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UserStartSolutionApplicationResponseStatus = typeof UserStartSolutionApplicationResponseStatus[keyof typeof UserStartSolutionApplicationResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserStartSolutionApplicationResponseStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  INACTIVE: 'INACTIVE',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
} as const;
